export const CATEGORY_ITEMS: Array<{ key: string; label: string }> = [
  {
    key: "",
    label: "Semua kategori",
  },
  {
    key: "resident",
    label: "MASTAUTIN",
  },
  {
    key: "non-resident",
    label: "BUKAN MASTAUTIN",
  },
];

export const CATEGORY_OPTIONS = CATEGORY_ITEMS.filter(
  (item) => item.key !== "",
).map((item) => ({
  value: item.key,
  label: item.label,
}));

export function normalizeResidencyStatusToCategoryKey(
  residencyStatus?: string | null,
) {
  const normalized = (residencyStatus ?? "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z]/g, "");

  if (!normalized) {
    return "";
  }

  if (normalized.includes("bukanmastautin")) {
    return "non-resident";
  }

  if (normalized.includes("mastautin")) {
    return "resident";
  }

  return "";
}

export function getCategoryOptionsForResidencyStatus(
  residencyStatus?: string | null,
) {
  void residencyStatus;

  return CATEGORY_OPTIONS;
}